// Single source of truth for the details that appear in the privacy policy,
// the terms of service, the support page, and the App Store listing.
//
// The Apple Developer account is Individual, not Organization, so the App
// Store seller line is fixed to the account holder's verified legal name.
// This has to match that name exactly.

export const COMPANY = "Ian Lewis";

export const SUPPORT_EMAIL = "support@lineupcfb.com";

export const GOVERNING_STATE = "North Carolina";

// Bump both dates when the substance of a document changes, not for typo fixes.
// Users are told to check these, so they have to mean something.
export const PRIVACY_UPDATED = "October 5, 2026";
export const TERMS_UPDATED = "August 23, 2026";

// The public account deletion page, submitted to the Play Console Data safety
// form. Dated separately from the privacy policy because Google looks at it as
// its own resource.
export const DELETE_ACCOUNT_UPDATED = "August 21, 2026";

export const MINIMUM_AGE = 18;
